import { useMutation, useQueryClient } from 'react-query';

import { initialBalancesApi } from 'src/Services/API';
import { CreateInitialBalancesBatchDto } from 'src/Services/API/generated';

interface UseCreateInitialBalancesBatchOptions {
  onSuccess?: () => void;
}

export const useCreateInitialBalancesBatch = (options?: UseCreateInitialBalancesBatchOptions) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ assetId, data }: { assetId: string; data: CreateInitialBalancesBatchDto }) =>
      initialBalancesApi.initialBalancesControllerCreateBatch(assetId, data),
    {
      onSuccess: (_, { assetId }) => {
        queryClient.invalidateQueries(['fetch-initial-balances', assetId]);
        queryClient.invalidateQueries(['fetch-expense-stats']);
        queryClient.invalidateQueries(['fetch-expense-balance']);
        queryClient.invalidateQueries(['fetch-household-balances']);
        queryClient.invalidateQueries(['fetch-personal-wallet']);
        queryClient.invalidateQueries(['fetch-asset-member-balances', assetId]);
        queryClient.invalidateQueries(['fetch-member-forecast-summary']);
        options?.onSuccess?.();
      },
    }
  );
};
